import gql from 'graphql-tag';

export default gql`
mutation changeAppManualLegs(
        $uuid: String!,
        $legsManual: String,
    ) {
    updateApps(input:{
        uuid: $uuid,
        legsManual: $legsManual
    }) {
        __typename
    }
}
`;
